/**
 * The landing cue (SA-1338): the one ring that says "you arrived here" on a deep-linked
 * record section, the Feasibility panel and the newly current process step. Keyboard
 * focus rings are a different cue and stay `focus-visible:ring-*`.
 */
export const LANDING_RING = 'ring-2 ring-primary/40'

/** The same ring for a mark drawn inside a card, lifted off the card's own surface. */
export const LANDING_RING_ON_CARD = `${LANDING_RING} ring-offset-2 ring-offset-card`
